import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { DatePipe } from '@angular/common';
declare var app;

@Component({
  selector: 'app-mz-schedule-approval',
  templateUrl: './mz-schedule-approval.component.html',
  styleUrls: ['./mz-schedule-approval.component.scss']
})
export class MzScheduleApprovalComponent extends GridBaseCase {
  month: any = new Date();
  searchDate = null;
  dataArrayList: Array<any> = [];
  addobject: any = {};
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  state:any;//状态
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) { 
    super(); 
    const d = this.activaRouter.snapshot.paramMap.get('id').split("&")[1];
    if(d){
      this.month = new Date((d+"-01").replace(/-/g,"/"));
    }
   /**
     * 设置默认当前年月
     */
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    this.month = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month)+"-01";

  }

  // ngOnInit() {
  // }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }

  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    that.state = that.activaRouter.snapshot.paramMap.get('type');
    const ID = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    const date = that.activaRouter.snapshot.paramMap.get('id').split("&")[1];
    
    if(that.state == 1 ){
      this.baseService.FixedSubmitBtn.configName = "scheduleapproval";
      this.baseService.FixedSubmitBtn.isShow = true;
      this.baseService.FixedSubmitBtn.type = 22;
    }
    if(this.state == 0){
      this.baseService.FixedSubmitBtn.configName = "scheduleapproval";
      this.baseService.FixedSubmitBtn.isShow = true;
      this.baseService.FixedSubmitBtn.type = 21;
    }
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 100;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // console.log(that.month);
      let obj = {};
      if (!that.searchDate) {
        let nowyear: any = date.split('-')[0];
        let nowmonth: any = date.split('-')[1];
        // obj["startDate"] = nowyear + "-" + nowmonth;
        let startDate = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
        let day = new Date(nowyear, nowmonth, 0);
        let endDate = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
        //obj["startDate"] = that.com.BetweenDate(startDate, endDate);
        that.searchDate = that.com.BetweenDate(startDate, endDate);
      }
      //排班
      obj["a_FK_SystemUser_ID"] = ID;
      obj["a_SNState"] = that.state;
      if (that.searchDate) {
        obj["a_SNStartDate"] = that.searchDate;
        // body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ModifyTime": that.searchDate });
      }
      body.RequestBody = JSON.stringify(obj);
      console.log(JSON.stringify(obj),"+++++++++++++++++++");
    }

    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          if(item.a_SchedulingMethod == 1 || item.a_SchedulingMethod == "1"){
            item.b_TypeName = "临时排班";
          }
          let objfield = {};
          
          that.element.selectItemList.selectItem.forEach((element, index) => {
            
           
            if (element.bindingField) {
              if(element.bindingField == "startdate" || element.bindingField == "enddate"){
                objfield[element.bindingField] = { "value": item[element.field].replace(/-/g,"/"), "text": element.text };
              }else{
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
             
            }
          });
         
         
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        console.log( that.dataArrayList,"数据显示");
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  changeMonth(type, $event:any="") {
    let t = type;
    const that=this;
    let current = new Date(this.month);
    let current_year = null;
    let current_month = null;
    if (t == 'pre') {
      current_year = current.getFullYear();
      current_month = this.getmonth(current.getMonth());
    } else if (t == 'next') {
      if((current.getMonth()+2)>12){
        current_year = current.getFullYear()+1;
        current_month = "01";
      }else{
        current_year = current.getFullYear();
        current_month = that.getmonth(current.getMonth() + 2);
      }
    } else if (t == 'datetime') {
      console.log($event.detail.value);
      current_year = $event.detail.value.split("-")[0];
      current_month = $event.detail.value.split("-")[1];
    }

    if (current_month == 13) {
      current_year += 1;
      current_month = 1;
    } else if (current_month == 0) {
      current_year -= 1;
      current_month = 12;
    }
    //获取月份对应的天数
    let d = new Date(current_year, current_month, 0);
    // console.log(d.getDate());

    let startmonthDay = current_year + "-" + current_month + "-" + "01 00:00:00";
    let endmonthDay = current_year + "-" + current_month + "-" + d.getDate() + " 23:59:59";
    // this.searchDate = current_year + "-" + current_month;
    this.searchDate = this.com.BetweenDate(startmonthDay, endmonthDay);
    this.month = current_year + '-' + current_month;
    console.log()
    if (t == 'datetime') {
      this.LoadData(1);
    }
  }

  EventLink(ev: any, item: any) {
    const that =this;
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
    let istrue:number=0;
    that.dataArrayList.forEach(items => {
      if(items.isCheck){
        istrue++;
      }
    });
    if(istrue==that.dataArrayList.length){
      that.baseService.FixedSubmitBtn["isCheckAll"]=true;
    }else{
      that.baseService.FixedSubmitBtn["isCheckAll"]=false;
    }
  }
  /**
   * 审批
   * @param event 通过:true,驳回:false
   */
  EventClick(event: Boolean) {
    // console.log(event);
    const that = this;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "TBScheduleNormalXML";
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    webcontext.SpecialParameter = "LeaveApproval";
    let message:string = "审批";
    if(!event){
      message="驳回";
    }
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        that.addobject = {};
        if (items.isCheck) {
          that.addobject["a_ID"] = items.ID.value;//主表ID
          if (event) {
            that.addobject["a_SNState"] = 1;
          } else {
            that.addobject["a_SNState"] = 2;
          }
          objArray.push(that.addobject);
        }
      });
      if(objArray.length<=0){
        that.msg.Alert("请选择需要"+message+"的排班");
        return;
      }
      let datepipe =new DatePipe("en-US");
      ////debugger;
      let isapprove:boolean=true;//是否可撤销
      let _monthDate:any = parseInt(that.com.getNow.replace(/-/g, "").replace("/", ""));
      that.dataArrayList.forEach(items=>{
        if(items.isCheck){
         let date:any= datepipe.transform(items.startdate.value.replace(/-/g, "/"),"yyyy-MM-dd");//撤销的日期
              date=parseInt(date.replace(/-/g, "").replace("/", ""));
              if(date<_monthDate){
                isapprove=false;
              }
            }
      });
      if(!isapprove){
        that.msg.Alert("只能"+message+"当天之后的排班");
        return;
      }
      console.log(that.dataArrayList[0]);
      console.log(that.dataArrayList,"&&&&&&&&&&&&&&&&");
      // console.log(JSON.stringify(objArray));
      webcontext.RequestBody = JSON.stringify(objArray);
      // console.log(JSON.stringify(webcontext));
      that.msg.Confirm("确定"+message+"吗？","取消","确定").then(res=>{
        if(res){
          that.http.post(app.DEFAULTURL, webcontext).then(data => {
            if (data.ResponseMessage.Success) {
               that.msg.Alert("排班"+message+"成功").then(res=>{
                that.LoadData(1);
               });
            } else {
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          });
        }
      });
   
    } else {
      that.msg.Alert("必须选择一项");
    }
  }
  ///批量撤销
  EventApproveClick(){
    const that = this;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "TBScheduleNormalXML";
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    // webcontext.SpecialParameter = "LeaveApproval"
    let datepipe =new DatePipe("en-US");
    let format:any="HH:mm";//过滤当前日期格式
    // that.fm.SNStartDate = datepipe.transform(that.obj["SNStartDate"].replace(/-/g, "/"),format);;//SNStartDate
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        that.addobject = {};
        if (items.isCheck) {
          that.addobject["a_ID"] = items.ID.value;//主表ID
          that.addobject["a_SNState"] = 3;//表示撤销
          objArray.push(that.addobject);
        }
      });
      if(objArray.length<=0){
        that.msg.Alert("请选择需要撤销的排班");
        return;
      }
     
      let datepipe =new DatePipe("en-US");
      let isapprove:boolean=true;//是否可撤销
      //debugger;
      let _monthDate:any = parseInt(that.com.getNow.replace(/-/g, "").replace("/", ""));
      that.dataArrayList.forEach(items=>{
        if(items.isCheck){
          let date:any= datepipe.transform(items.startdate.value.replace(/-/g, "/"),"yyyy-MM-dd");//撤销的日期
          date=parseInt(date.replace(/-/g, "").replace("/", ""));
          if(date<_monthDate){
            isapprove=false;
          }
        }
      });
      if(!isapprove){
        that.msg.Alert("只能撤销当天之后的排班");
        return;
      }
      //console.log(that.dataArrayList[0]);
      // console.log(JSON.stringify(objArray));
      webcontext.RequestBody = JSON.stringify(objArray);
      // console.log(JSON.stringify(webcontext));
     that.msg.Confirm("确定撤销吗？","取消","确定").then(res=>{
        if(res){
          that.http.post(app.DEFAULTURL, webcontext).then(data => {
            if (data.ResponseMessage.Success) {
              that.msg.Alert("排班撤销成功").then(res=>{
                that.LoadData(1);
              });
             
            } else {
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          });
        }
     });
    } else {
      that.msg.Alert("必须选择一项");
    }
  }
   /**
   * 全选状态切换
   */
  EventCheckAllToggle() {
    const that = this;
    if (that.baseService.FixedSubmitBtn["isCheckAll"]) {
      that.dataArrayList.forEach(items => {
        console.log(items,"集合");
        items.isCheck = true;
      });
    } else {
      that.dataArrayList.forEach(items => {
        items.isCheck = false;
      });
    }
  }
  getmonth(month: Number) {
    let months: any = month;
    if (month < 10) {
      months = "0" + month
    }
    return months;
  }

}
